import { requestAndParse, requestSuccessful } from '../request';

const forgotPassword = async (email: string) => {
    const route = 'auth/forgot-password';

    const payload = {
        email,
        dashboard: true,
    };

    const response = await requestAndParse(route, payload);

    return {
        success: requestSuccessful(response),
        message: response.body?.message as string | undefined,
    };
};

export default forgotPassword;
